export default __webpack_public_path__ + "static/tickets-d449693da4026eed9f4852c170192459.png";